import type { Problem } from '@/api/sirta/problems';
import type { TranslatableLabel } from '@/types';

/**
 * "raison" associée à l'établissement en question, selon la définition proposée par HOD.
 * @example "M" pour "medical", "E", "S", etc.
 */
export enum LandmarkReasonDto {
  Medical = 'M',
}

export type LandmarkDto = {
  name: TranslatableLabel;
  type: string;
  /** "raison" associée à l'établissement en question, selon la définition proposée par HOD. */
  tripReason: LandmarkReasonDto | string;
  note: TranslatableLabel;
};

export type WellKnownPlaceDto = LandmarkDto | string;

/** Une adresse. */
export type AddressDto = {
  /** Clé unique sérialisée représentant l'adresse */
  key: string;
  /** Est-ce que l'adresse est le domicile du client? */
  isHome: boolean;
  /** Un endroit nommé, soit un lieu public de HOD ou simplement une adresse associée à un nom de bâtiment. */
  place: WellKnownPlaceDto | null;
  /** L'adresse courte, sans la municipalité, pour l'affichage sur une ligne. */
  address: string;
  /** Numéro civique */
  civicNumber: string | null;
  /**
   * Concaténation des champs "civic number", "type de rue", "nom",
   * "orientation" et "suite" effectué par le backend pour l'affichage unifié d'une adresse complète.
   */
  streetDescription: string | null;
  /** Suite/appartement, s'il y a lieu */
  suite: string | null;
  /** La municipalité, lorsqu'on affiche plusieurs lignes d'adresses. */
  municipality: string;
  /** Instruction au chauffeur */
  instruction: TranslatableLabel | null;
  /** code postal */
  postalCode: string | null;
  /** Coordonnées géographiques de l'adresse sous forme d'un tuple [longitude, latitude] */
  coordinateWgs84?: [number, number] | null;
};

/** Réponse retournée par les API d'adresses favorites et historiques, et pour la recherche d'adresses */
export type BookingAddressResponseDto = {
  /** Les adresses classées par pertinence en ordre décroissant. */
  addresses: AddressDto[];
  /** Liste de problèmes rencontrés lors de la préparation des résultats ou un tableau vide sinon. */
  problems: Problem[];
};
